// Chronological ordering for calendar events.
//
// Events mix time coordinate systems: all-day events are normalised to a
// zone-less local-midnight string (AC4) while timed events keep their raw UTC
// `Z` string. A lexicographic string compare (`a.start.localeCompare(b.start)`)
// therefore orders those two systems incorrectly. Comparing the parsed instants
// numerically is the only correct ordering — this is the single comparator every
// view uses (month buckets, day column, Up-next rail).

import { parseISO } from 'date-fns'
import type { CalendarEvent } from './typings'

/** Ascending by actual start instant. Stable for equal starts. */
export function compareEventsByStart(
  a: CalendarEvent,
  b: CalendarEvent,
): number {
  return parseISO(a.start).getTime() - parseISO(b.start).getTime()
}
